export const userPlanOptions = ["FREE", "PRO"] as const;

export const userPlanVariantOptions = [
  "PRO_3_DAYS",
  "PRO_1_WEEK",
  "PRO_1_MONTH",
] as const;

export const userSubscriptionStatusOptions = [
  "NONE",
  "ACTIVE",
  "TRIALING",
  "PAST_DUE",
  "CANCELED",
  "INCOMPLETE",
  "INCOMPLETE_EXPIRED",
  "PAUSED",
  "UNPAID",
] as const;
